const _ = require('lodash');

const getQueryParameterByName = require('../helpers/GetQueryParam');

const variantId = _.get(document.referrer.match('\/p\/(V\-[0-9]+)'), 1);
const domain = _.get(document.referrer.match('\/\/([a-z0-9\.\-]+)\/'), 1);
const configId = _.get(document.referrer.match('configId\=CFG[0-9]*0([1-9]{1}[0-9]+)'), 1);
const url = document.referrer;

const ZalesLoader = {
  productId: getQueryParameterByName('id'), // _.get(location.pathname.match(/([0-9]{4,})/), 1),
  configId,
  siteId: getQueryParameterByName('hs'),
  userId: getQueryParameterByName('hu'),
  cartId: getQueryParameterByName('hc'),
  envId: getQueryParameterByName('he'),
  variantId,
  domain,
  url,
  addToCartUrl: false
};

export default ZalesLoader;


// WEBPACK FOOTER //
// ./src/base/scripts/loaders/zales.js